// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== GENERAL WRAPPER ========== */
.aan-wrapper {
  font-family: "Inter", sans-serif;
  background: #fafafa;
  padding-bottom: 80px;
}

/* Remove any bullets from empty ULs */
.remove-bullets,
.remove-bullets ul,
.remove-bullets li {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
}
.aan-centered-card {
  text-align: center;
  padding: 40px !important;
  background: white;
  border-radius: 30px;
  box-shadow: 0px 5px 15px rgba(0,0,0,0.1);
}

.aan-centered-checklist {
  list-style: none !important;
  padding: 0;
  margin: 20px auto 0;
  display: inline-block;
  text-align: left;
}

.aan-centered-checklist li {
  font-size: 1.3rem;
  margin: 8px 0;
}


/* ========== ACCESS CODE OVERLAY ========== */
.aan-access-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.aan-access-box {
  background: white;
  padding: 35px 40px;
  border-radius: 12px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  text-align: center;
}

.aan-access-title {
  font-size: 22px;
  margin-bottom: 20px;
}

.aan-access-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

.aan-access-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.aan-access-verify-btn {
  background: #007bff;
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
}

.aan-access-cancel-btn {
  background: #d9534f;
  color: white;
  padding: 10px 14px;
  border-radius: 6px;
}

/* ========== LOGO ========== */
.aan-logo-wrapper {
  text-align: center;
  margin: 30px auto 20px auto;
}

.aan-logo {
  width: 260px;
}

/* ========== BANNER ========== */
.aan-banner {
  position: relative;
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 18px;
  overflow: hidden;
}

.aan-banner-img {
  width: 100%;
  height: 380px;
  object-fit: cover;
  filter: brightness(45%);
}

.aan-banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 38px;
  font-weight: 700;
  text-align: center;
  padding: 0 20px;
}
/* PDF VIEWER WRAPPER - FIX HEIGHT + SCROLL */
.aan-pdf-viewer-wrapper {
  width: 100%;
  max-width: 900px; 
  height: 650px;      /* FIXED HEIGHT FOR DESKTOP */
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  overflow: hidden;
}

/* The actual PDF viewer becomes scrollable */
.aan-pdf-scroll-area {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border-radius: 10px;
}

/* Responsive PDF height adjustment */
@media (max-width: 768px) {
  .aan-pdf-viewer-wrapper {
      height: 500px;  /* Smaller height for tablets */
  }
}

@media (max-width: 480px) {
  .aan-pdf-viewer-wrapper {
      height: 400px; /* Best for small mobile screens */
  }
}


/* MOBILE FIX */
@media (max-width: 600px) {
  .aan-banner-img {
      height: 280px;
  }
  .aan-banner-text {
      font-size: 26px;
      width: 90%;
  }
}

/* ========== SECTION ROWS ========== */
.aan-section-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 90%;
  max-width: 1400px;
  margin: 60px auto;
}

.aan-section-row.reverse {
  flex-direction: row-reverse;
}

/* ========== TEXT BLOCK ========== */
.aan-text-block {
  flex: 1 1;
  background: white;
  padding: 35px 40px;
  border-radius: 15px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
}

.aan-text-block h2 {
  color: #333;
  margin-bottom: 15px;
}

/* ========== IMAGE BLOCK ========== */
.aan-img-block {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.aan-img-block img {
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 7px 18px rgba(0, 0, 0, 0.18);
}

/* MOBILE STACK FIX */
@media (max-width: 880px) {
  .aan-section-row {
      flex-direction: column !important;
  }
  .aan-img-block img {
      max-width: 90%;
  }
}

/* ========== CENTER TEXT BLOCK ========== */
.aan-center-box {
  width: 90%;
  max-width: 800px;
  margin: 70px auto;
  background: white;
  padding: 45px;
  border-radius: 18px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);
}

/* MOBILE */
@media (max-width: 700px) {
  .aan-center-box {
      padding: 30px 20px;
  }
}

/* ========== PDF SECTION ========== */
.aan-pdf-section {
  display: flex;
  justify-content: center;
  gap: 40px;
  width: 90%;
  max-width: 1500px;
  margin: 60px auto;
}

/* LEFT COLUMN */
.aan-button-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 280px;
}

/* BUTTONS */
.aan-btn {
  padding: 18px 0;
  font-size: 17px;
  font-weight: 600;
  color: white;
  border-radius: 12px;
  border: none;
  cursor: pointer;
}

.aan-btn.red {
  background: #c62828;
}

.aan-btn.green {
  background: #1d439a;
}

/* PDF VIEWER */
.aan-pdf-viewer {
  flex: 1 1;
  min-height: 750px;
  background: #f5f5f5;
  border-radius: 16px;
  padding: 20px;
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.15);
  overflow: auto;
}

/* MOBILE PDF FIX */
@media (max-width: 900px) {
  .aan-pdf-section {
      flex-direction: column;
      align-items: center;
  }
  .aan-button-column {
      width: 100%;
      max-width: 400px;
  }
  .aan-pdf-viewer {
      width: 100%;
      min-height: 500px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AAN/AANOnboarding.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;;;IAGI,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;AACzB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;;AAGA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,6CAA6C;AAC7C;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa,OAAO,6BAA6B;EACjD,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;MACI,aAAa,GAAG,+BAA+B;EACnD;AACF;;AAEA;EACE;MACI,aAAa,EAAE,kCAAkC;EACrD;AACF;;;AAGA,eAAe;AACf;EACE;MACI,aAAa;EACjB;EACA;MACI,eAAe;MACf,UAAU;EACd;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE;MACI,iCAAiC;EACrC;EACA;MACI,cAAc;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE;MACI,kBAAkB;EACtB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE;MACI,sBAAsB;MACtB,mBAAmB;EACvB;EACA;MACI,WAAW;MACX,gBAAgB;EACpB;EACA;MACI,WAAW;MACX,iBAAiB;EACrB;AACF","sourcesContent":["/* ========== GENERAL WRAPPER ========== */\n.aan-wrapper {\n  font-family: \"Inter\", sans-serif;\n  background: #fafafa;\n  padding-bottom: 80px;\n}\n\n/* Remove any bullets from empty ULs */\n.remove-bullets,\n.remove-bullets ul,\n.remove-bullets li {\n    list-style: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n.aan-centered-card {\n  text-align: center;\n  padding: 40px !important;\n  background: white;\n  border-radius: 30px;\n  box-shadow: 0px 5px 15px rgba(0,0,0,0.1);\n}\n\n.aan-centered-checklist {\n  list-style: none !important;\n  padding: 0;\n  margin: 20px auto 0;\n  display: inline-block;\n  text-align: left;\n}\n\n.aan-centered-checklist li {\n  font-size: 1.3rem;\n  margin: 8px 0;\n}\n\n\n/* ========== ACCESS CODE OVERLAY ========== */\n.aan-access-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.aan-access-box {\n  background: white;\n  padding: 35px 40px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 420px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  text-align: center;\n}\n\n.aan-access-title {\n  font-size: 22px;\n  margin-bottom: 20px;\n}\n\n.aan-access-input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n\n.aan-access-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.aan-access-verify-btn {\n  background: #007bff;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 6px;\n}\n\n.aan-access-cancel-btn {\n  background: #d9534f;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 6px;\n}\n\n/* ========== LOGO ========== */\n.aan-logo-wrapper {\n  text-align: center;\n  margin: 30px auto 20px auto;\n}\n\n.aan-logo {\n  width: 260px;\n}\n\n/* ========== BANNER ========== */\n.aan-banner {\n  position: relative;\n  width: 90%;\n  max-width: 1400px;\n  margin: 0 auto;\n  border-radius: 18px;\n  overflow: hidden;\n}\n\n.aan-banner-img {\n  width: 100%;\n  height: 380px;\n  object-fit: cover;\n  filter: brightness(45%);\n}\n\n.aan-banner-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 38px;\n  font-weight: 700;\n  text-align: center;\n  padding: 0 20px;\n}\n/* PDF VIEWER WRAPPER - FIX HEIGHT + SCROLL */\n.aan-pdf-viewer-wrapper {\n  width: 100%;\n  max-width: 900px; \n  height: 650px;      /* FIXED HEIGHT FOR DESKTOP */\n  margin: 20px auto;\n  background: #fff;\n  border-radius: 12px;\n  padding: 10px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  overflow: hidden;\n}\n\n/* The actual PDF viewer becomes scrollable */\n.aan-pdf-scroll-area {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  border-radius: 10px;\n}\n\n/* Responsive PDF height adjustment */\n@media (max-width: 768px) {\n  .aan-pdf-viewer-wrapper {\n      height: 500px;  /* Smaller height for tablets */\n  }\n}\n\n@media (max-width: 480px) {\n  .aan-pdf-viewer-wrapper {\n      height: 400px; /* Best for small mobile screens */\n  }\n}\n\n\n/* MOBILE FIX */\n@media (max-width: 600px) {\n  .aan-banner-img {\n      height: 280px;\n  }\n  .aan-banner-text {\n      font-size: 26px;\n      width: 90%;\n  }\n}\n\n/* ========== SECTION ROWS ========== */\n.aan-section-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 40px;\n  width: 90%;\n  max-width: 1400px;\n  margin: 60px auto;\n}\n\n.aan-section-row.reverse {\n  flex-direction: row-reverse;\n}\n\n/* ========== TEXT BLOCK ========== */\n.aan-text-block {\n  flex: 1;\n  background: white;\n  padding: 35px 40px;\n  border-radius: 15px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\n}\n\n.aan-text-block h2 {\n  color: #333;\n  margin-bottom: 15px;\n}\n\n/* ========== IMAGE BLOCK ========== */\n.aan-img-block {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.aan-img-block img {\n  width: 100%;\n  max-width: 500px;\n  border-radius: 20px;\n  box-shadow: 0 7px 18px rgba(0, 0, 0, 0.18);\n}\n\n/* MOBILE STACK FIX */\n@media (max-width: 880px) {\n  .aan-section-row {\n      flex-direction: column !important;\n  }\n  .aan-img-block img {\n      max-width: 90%;\n  }\n}\n\n/* ========== CENTER TEXT BLOCK ========== */\n.aan-center-box {\n  width: 90%;\n  max-width: 800px;\n  margin: 70px auto;\n  background: white;\n  padding: 45px;\n  border-radius: 18px;\n  text-align: center;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);\n}\n\n/* MOBILE */\n@media (max-width: 700px) {\n  .aan-center-box {\n      padding: 30px 20px;\n  }\n}\n\n/* ========== PDF SECTION ========== */\n.aan-pdf-section {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  width: 90%;\n  max-width: 1500px;\n  margin: 60px auto;\n}\n\n/* LEFT COLUMN */\n.aan-button-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 280px;\n}\n\n/* BUTTONS */\n.aan-btn {\n  padding: 18px 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: white;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n}\n\n.aan-btn.red {\n  background: #c62828;\n}\n\n.aan-btn.green {\n  background: #1d439a;\n}\n\n/* PDF VIEWER */\n.aan-pdf-viewer {\n  flex: 1;\n  min-height: 750px;\n  background: #f5f5f5;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.15);\n  overflow: auto;\n}\n\n/* MOBILE PDF FIX */\n@media (max-width: 900px) {\n  .aan-pdf-section {\n      flex-direction: column;\n      align-items: center;\n  }\n  .aan-button-column {\n      width: 100%;\n      max-width: 400px;\n  }\n  .aan-pdf-viewer {\n      width: 100%;\n      min-height: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
